var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "row" }, [
      _c("aside", { staticClass: "col-3 col-12-sm sticky-filter" }, [
        _c("div", { staticClass: "news-filter" }, [
          _c(
            "form",
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search",
                  },
                ],
                attrs: { type: "text", placeholder: "Suche" },
                domProps: { value: _vm.search },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.search = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.orderedCategories, function (category) {
                return _c("div", { staticClass: "radio-wrap" }, [
                  _c(
                    "label",
                    { staticClass: "container", attrs: { for: category.id } },
                    [
                      _vm._v(
                        _vm._s(category.name) + "\n                            "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.categoryFilter,
                            expression: "categoryFilter",
                          },
                        ],
                        attrs: { type: "radio", id: category.id },
                        domProps: {
                          value: category.id,
                          checked: _vm._q(_vm.categoryFilter, category.id),
                        },
                        on: {
                          change: function ($event) {
                            _vm.categoryFilter = category.id
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkmark" }),
                    ]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-9 col-12-sm", attrs: { id: "newslist" } },
        [
          _vm._l(_vm.filteredResults, function (value, index) {
            return [
              _vm.checkDate(
                value.date,
                _vm.filteredResults[_vm.checkIndex(index)].date,
                index
              )
                ? _c("h2", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.getMonth(
                          value.date,
                          _vm.filteredResults[_vm.checkIndex(index)].date
                        )
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "teaser", class: { upright: value.upright } },
                [
                  _c(
                    "figure",
                    {
                      directives: [
                        {
                          name: "lazy-container",
                          rawName: "v-lazy-container",
                          value: { selector: "img" },
                          expression: "{ selector: 'img' }",
                        },
                      ],
                    },
                    [
                      _c("img", { attrs: { "data-src": value.img_url } }),
                      _vm._v(" "),
                      _c("footer", [
                        value.img_caption
                          ? _c("small", {
                              domProps: {
                                innerHTML: _vm._s(value.img_caption),
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "teaser__info" }, [
                    _c("h3", [
                      _c("a", {
                        attrs: { href: value.link, tabindex: "-1" },
                        domProps: { innerHTML: _vm._s(value.title) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          value.excerpt.substring(0, 60) + " ..."
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "btn",
                    attrs: { href: value.link },
                    domProps: { innerHTML: _vm._s(_vm.linktext) },
                  }),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }